<template>
<v-layout row wrap justify-center>
  <v-flex xs1 v-if="!loadedCabin">
    <v-progress-circular
      indeterminate
      color="light-green darken-1"
    ></v-progress-circular>
  </v-flex>
  <v-flex xs12 v-if="loadedCabin">
    <v-list two-line>
      <v-list-tile
        v-if="cabinRes.length == 0"
      >
        <v-list-tile-content>
          <v-alert
            :value="true"
            type="info"
          >
            No hay reservas para esta cabaña
          </v-alert>
        </v-list-tile-content>
      </v-list-tile>
      <template v-for="(reserva, index) in cabinRes">
        <v-list-tile :key="index" class="px-0" @click="navigateTo('Reserva', {reserva: reserva.id})">
          <v-list-tile-content class="px-0">
            <v-layout row wrap align-center fill-height style="width: 100%">
              <v-flex xs6 sm7 md9>
                <v-list-tile-title >{{reserva.reservation_data.name.firstname}} {{reserva.reservation_data.name.lastname}}</v-list-tile-title>
                <v-list-tile-sub-title>Huéspedes: {{reserva.reservation_data.guests}}</v-list-tile-sub-title>
                <v-list-tile-sub-title>Mes<span v-if="reservationMonths(reserva.reservation_data)[1]">es</span> : {{reservationMonths(reserva.reservation_data)[0] | monthName}} {{reservationMonths(reserva.reservation_data)[1] | monthName}} </v-list-tile-sub-title>
              </v-flex>
              <v-flex xs6 sm5 md3>
                <v-layout row align-center fill-height>
                  <v-flex>
                    <v-chip color="green" text-color="white" class="rotate">
                      <v-avatar right class="green darken-4 rotate">{{reserva.reservation_data.arrival | date}}</v-avatar>
                      <span class="rotate hidden-xs-only">{{reserva.reservation_data.arrival | weekDay}}</span>
                    </v-chip>
                    A
                    <v-chip color="green" text-color="white" class="rotate">
                      <v-avatar right class="green darken-4 rotate">{{reserva.reservation_data.departure | date}}</v-avatar>
                      <span class="rotate hidden-xs-only">{{reserva.reservation_data.departure | weekDay}}</span>
                    </v-chip>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider v-if="index + 1 < cabinRes.length" :key="`divider-${index}`"></v-divider>
      </template>
    </v-list>
  </v-flex>
</v-layout>
</template>
<script>
import filters from '@/mixins/filters'
import mixins from '@/mixins/mixins'

export default {
  props: ['id'],
  mixins: [
    mixins,
    filters
  ],
  data() {
    return {
      loadedCabin: false,
      cabinRes: null,
    }
  },
  computed: {
    reservas() {
      return this.$store.state.reservas;
    },
    loadedReservas() {
      return this.$store.state.loadedReservas;
    },
  },
  methods: {
    reservationMonths(reservationData) {
      const arrivalMonth = new Date(reservationData.arrival).getMonth();
      const departureMonth = new Date(reservationData.departure).getMonth();
      if (arrivalMonth === departureMonth) {
        return [arrivalMonth]
      } else {
        return [arrivalMonth, departureMonth]
      }
    }
  },
  created() {
    if (this.loadedReservas) {
      let a = this.reservas.filter(res => res.reservation_data.cabin == this.id);
      this.cabinRes = a;
      this.loadedCabin = true;
    };
  },
  watch: {
    loadedReservas: function() {
      let a = this.reservas.filter(res => res.reservation_data.cabin == this.id);
      this.cabinRes = a;
      this.loadedCabin = true;
    }
  }
}
</script>
